module.exports = __webpack_public_path__ + "static/media/1003192.4f882d9e.png";